/* TERCER DÍA V36. La cabecera se mantiene visible bajando y subiendo.
   La cinta conserva su posición normal y su animación sin hacerse sticky. */
(() => {
  const nav = document.querySelector('.nav.v46-nav');
  const spacer = document.querySelector('.td-sticky-nav-spacer');
  if (!nav || !spacer) return;
  const root = document.body;
  const ticker = document.querySelector('.topbar.ticker');
  const mq = window.matchMedia('(max-width:720px)');
  let ticking = false;
  let lastFixed = null;
  const flow = () => {
    if (root.classList.contains('td-nav-fixed')) return;
    root.classList.toggle('td-nav-flow', getComputedStyle(nav).position !== 'absolute');
  };
  const sync = () => {
    ticking = false;
    const threshold = ticker ? ticker.getBoundingClientRect().height : 0;
    const fixed = window.scrollY >= Math.max(1, threshold);
    if (fixed === lastFixed) return;
    root.classList.toggle('td-nav-fixed', fixed);
    lastFixed = fixed;
  };
  const update = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(sync);
  };
  flow();
  sync();
  window.addEventListener('scroll', update, { passive:true });
  window.addEventListener('resize', () => {
    if (!root.classList.contains('td-nav-fixed')) flow();
    update();
  }, { passive:true });
  mq.addEventListener?.('change', () => {
    root.classList.remove('td-nav-fixed');
    lastFixed = null;
    flow();
    update();
  });
})();
